<script>
// import { Us, Tr } from "svelte-flags";
import { languages } from "$lib/data";
// import * as Select from '$lib/components/ui/select';
import {
  setLocale,
  getLocale,
  locales,
  // localizeHref
} from "$lib/paraglide/runtime";
import { cn } from "$lib/utils";

const _defaultLang = getLocale();

let lang = $state(_defaultLang);

let { class: klass } = $props();

$effect(() => {
  // console.log('locales', locales);
  // console.log('lang', lang);
  setLocale(lang);
});

// const languages = [
//   {
//     code: "en",
//     iso: "en-US",
//     name: "English",
//     native: "English",
//     dir: "ltr",
//     path: "/en/",
//     flag: Us,
//   },
//   {
//     code: "tr",
//     iso: "tr-TR",
//     name: "Turkish",
//     native: "Türkçe",
//     dir: "ltr",
//     path: "/tr/",
//     flag: Tr,
//   },
// ];

const selectedLanguage = $derived(languages.find((l) => l.code === lang));
// const SelectedFlag = $derived(selectedLanguage.flag);
</script>

<!-- <div class="text-high-contrast">
  <SelectedFlag size="16" />
  {selectedLanguage.native}
</div> -->
<ul class={cn("flex", "gap-1", "text-high-contrast", klass)}>
  {#each locales as locale (locale)}
    {@const language = languages.find((l) => l.code === locale)}
    {@const Flag = language.flag}
    <li>
      <button
        class={cn("btn", "px-2.5", "py-1.5", "text-xs", "md:text-sm", selectedLanguage.code === locale && "btn-active")}
        onclick={() => (lang = locale)}
      >
        <Flag size="22" />
        <span>{language.native}</span>
      </button>
    </li>
  {/each}
</ul>
